import ListingHeader from "../../../components/listingHeader/listingHeader";
import SBEditable from "../../../components/sbEditable/sbEditable";
import { RenderStoryblokComponent } from "../../../helpers/bloksRenderer";

import { useResolvedRecommendedProducts } from "../../../hooks/useStoryblokProducts";

import styles from "./recommendedProductsListingPanel.module.scss";

//get products from global settings
function RecommendedProductsListingPanel({ blok, story_language }) {
  const recommendedProductBloks = useResolvedRecommendedProducts();

  return (
    <SBEditable withClass={styles.root} blok={blok} key={blok._uid}>
      {recommendedProductBloks && recommendedProductBloks.length > 0 ? (
        <>
          <ListingHeader underlineColor={blok.header_underline_color}>
            <h2>{blok.header}</h2>
          </ListingHeader>
          {recommendedProductBloks.map((itemBlok) => (
            <div className={styles.itemWrapper} key={itemBlok._uid}>
              {RenderStoryblokComponent(itemBlok, null, story_language)}
            </div>
          ))}
        </>
      ) : null}
    </SBEditable>
  );
}

export default RecommendedProductsListingPanel;
